export default "__VITE_ASSET__996bede5__"